import mainMenu from '@/config/menus/main'
import notificationsMenu from '@/config/menus/notifications'
import companiesMenu from '@/config/menus/companies'
import certificatesMenu from '@/config/menus/certificates'
import replacecertificate from '@/config/menus/replacecertificate'
import configUsersMenu from '@/config/menus/configurationsUsers'
import notificationsNew from '@/config/menus/notificationsNew'
import presentationsNew from '@/config/menus/presentationsNew'
import configLocationsMenu from '@/config/menus/configurationsLocations'
import configurationsGroups from '@/config/menus/configurationsGroups'
import configurationsGroupingMain from '@/config/menus/configurationsGroupingMain'
import configurationsGrouping from '@/config/menus/configurationsGrouping'
import configurationsRules from '@/config/menus/configurationsRules'
import configurationsConfigFlow from '@/config/menus/configurationsConfigFlow'
import configurationsOrgProvinces from '@/config/menus/configurationsOrgProvinces'
import configurationsProcedings from '@/config/menus/configurationsProcedings'
import configurationsAPIRequests from '@/config/menus/configurationsAPIRequests'
import configurationsTrashGroups from '@/config/menus/configurationsTrashGroups'
import configurationsClients from '@/config/menus/configurationsClients'
import configurationsDistributors from '@/config/menus/configurationsDistributors'
import configurationsTrashCertificates from '@/config/menus/configurationsTrashCertificates'
import configurationsTrashCompanies from '@/config/menus/configurationsTrashCompanies'
import configurationsTrashNotifications from '@/config/menus/configurationsTrashNotifications'
import configurationsTrashUsers from '@/config/menus/configurationsTrashUsers'
import { getNotificationsStatus } from '@/services/app/getNotificationsStatus'

const state = () => ({
  gettingNotificationsMenu: false,
})

const getters = {
  mainMenu: () => {
    const main = mainMenu()
    return main
  },
  secondaryMenu: (state) => (menu, params) => {
    switch (menu) {
      case 'notifications':
        return notificationsMenu(params)
      case 'companies':
        return companiesMenu(params)
      case 'certificates':
        return certificatesMenu(params)
      case 'replacecertificate':
        return replacecertificate(params)
      case 'configurations/users':
        return configUsersMenu(params)
      case 'configurations/groups':
        return configurationsGroups(params)
      case 'configurations/grouping/main':
        return configurationsGroupingMain(params)
      case 'configurations/grouping':
        return configurationsGrouping(params)
      case 'configurations/rules':
        return configurationsRules(params)
      case 'configurations/configflow':
        return configurationsConfigFlow(params) 
      case 'configurations/orgprovinces':
        return configurationsOrgProvinces(params) 
      case 'procedings':
        return configurationsProcedings(params)
      case 'configurations/apirequests':
        return configurationsAPIRequests(params) 
      case 'configurations/locations':
        return configLocationsMenu(params)
      case 'configurations/clients':
        return configurationsClients(params)
      case 'configurations/distributors':
        return configurationsDistributors(params)
      case 'configurations/trash/certificates':
        return configurationsTrashCertificates(params)
      case 'configurations/trash/companies':
        return configurationsTrashCompanies(params)
      case 'configurations/trash/notifications':
        return configurationsTrashNotifications(params)
      case 'configurations/trash/users':
        return configurationsTrashUsers(params)
      case 'configurations/trash/groups':
        return configurationsTrashGroups(params)
      case 'notifications/new':
        return notificationsNew()
      case 'presentations/new':
        return presentationsNew(params)
      default:
        return []
    }
  }
}

const mutations = {
  setMainMenu (state, mainMenu) {
    state.mainMenu = mainMenu
  },
  get_menu_request (state) {
    state.gettingNotificationsMenu = true
  },
  get_menu_success (state, notifications) {
    state.NotificationsStatus = notifications
    state.gettingNotificationsMenu = false
  },
  get_menu_error (state) {
    state.gettingNotificationsMenu = false
  }
}

const actions = {
  getNotificationsMenu ({ commit }, estado) {
    return new Promise((resolve, reject) => {
      commit('get_menu_request')
      getNotificationsStatus().then(response => {
        if (response.blnError) {
          commit('get_menu_error')
          return Promise.reject(response)
        }
        commit('get_menu_success', response.respuesta)
        resolve(response)
      })
        .catch(err => {
          commit('get_menu_error')
          reject(err)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
